{
  "v": "4.5.7",
  "fr": 30,
  "ip": 0,
  "op": 97,
  "w": 512,
  "h": 512,
  "ddd": 0,
  "assets": [
    {
      "id": "comp_29",
      "layers": [
        {
          "ddd": 0,
          "ind": 0,
          "ty": 0,
          "nm": "L 1",
          "refId": "comp_30",
          "ks": {
            "o": { "a": 0, "k": 100 },
            "r": {
              "a": 1,
              "k": [
                {
                  "i": { "x": [0.833], "y": [0.833] },
                  "o": { "x": [0.167], "y": [0.167] },
                  "n": ["0p833_0p833_0p167_0p167"],
                  "t": 0,
                  "s": [324],
                  "e": [-756]
                },
                { "t": 96 }
              ]
            },
            "p": { "a": 0, "k": [960, 540, 0] },
            "a": { "a": 0, "k": [960, 540, 0] },
            "s": { "a": 0, "k": [100, 100, 100] }
          },
          "ao": 0,
          "w": 1920,
          "h": 1080,
          "ip": 0,
          "op": 97,
          "st": 0,
          "bm": 0,
          "sr": 1
        }
      ]
    },
    {
      "id": "comp_30",
      "layers": [
        {
          "ddd": 0,
          "ind": 1,
          "ty": 3,
          "nm": "R G 6",
          "ks": {
            "o": { "a": 0, "k": 100 },
            "r": {
              "a": 1,
              "k": [
                {
                  "i": { "x": [0.667], "y": [1] },
                  "o": { "x": [0.333], "y": [0] },
                  "n": ["0p667_1_0p333_0"],
                  "t": 80,
                  "s": [0],
                  "e": [191]
                },
                {
                  "i": { "x": [0.667], "y": [1] },
                  "o": { "x": [0.333], "y": [0] },
                  "n": ["0p667_1_0p333_0"],
                  "t": 93,
                  "s": [191],
                  "e": [180]
                },
                { "t": 96 }
              ]
            },
            "p": { "a": 0, "k": [1050, 540, 0] },
            "a": { "a": 0, "k": [-5.266, 38.734, 0] },
            "s": { "a": 0, "k": [36, 36, 100] }
          },
          "ao": 0,
          "ip": 80,
          "op": 97,
          "st": 80,
          "bm": 0,
          "sr": 1
        },
        {
          "ddd": 0,
          "ind": 2,
          "ty": 4,
          "nm": "18",
          "ks": {
            "o": { "a": 0, "k": 100 },
            "r": { "a": 0, "k": 0 },
            "p": { "a": 0, "k": [780, 540, 0] },
            "a": { "a": 0, "k": [-5.266, 38.734, 0] },
            "s": { "a": 0, "k": [170, 170, 100] }
          },
          "ao": 0,
          "shapes": [
            {
              "ty": "gr",
              "it": [
                {
                  "d": 1,
                  "ty": "el",
                  "s": { "a": 0, "k": [49.469, 49.469] },
                  "p": { "a": 0, "k": [0, 0] },
                  "nm": "Ellipse Path 1",
                  "mn": "ADBE Vector Shape - Ellipse"
                },
                {
                  "ty": "st",
                  "c": { "a": 0, "k": [0.44, 0.13, 0.47, 1] },
                  "o": { "a": 0, "k": 100 },
                  "w": { "a": 0, "k": 0 },
                  "lc": 1,
                  "lj": 1,
                  "ml": 4,
                  "nm": "Stroke 1",
                  "mn": "ADBE Vector Graphic - Stroke"
                },
                {
                  "ty": "fl",
                  "c": { "a": 0, "k": [1, 0.73, 0, 1] },
                  "o": { "a": 0, "k": 100 },
                  "nm": "Fill 1",
                  "mn": "ADBE Vector Graphic - Fill"
                },
                {
                  "ty": "tr",
                  "p": { "a": 0, "k": [-5.266, 38.734], "ix": 2 },
                  "a": { "a": 0, "k": [0, 0], "ix": 1 },
                  "s": { "a": 0, "k": [100, 100], "ix": 3 },
                  "r": { "a": 0, "k": 0, "ix": 6 },
                  "o": { "a": 0, "k": 100, "ix": 7 },
                  "sk": { "a": 0, "k": 0, "ix": 4 },
                  "sa": { "a": 0, "k": 0, "ix": 5 },
                  "nm": "Transform"
                }
              ],
              "nm": "Ellipse 1",
              "np": 3,
              "mn": "ADBE Vector Group"
            }
          ],
          "ip": 80,
          "op": 97,
          "st": 80,
          "bm": 0,
          "sr": 1
        },
        {
          "ddd": 0,
          "ind": 3,
          "ty": 4,
          "nm": "17",
          "parent": 1,
          "ks": {
            "o": { "a": 0, "k": 100 },
            "r": { "a": 0, "k": 0 },
            "p": { "a": 0, "k": [-255.266, 38.734, 0] },
            "a": { "a": 0, "k": [-5.266, 38.734, 0] },
            "s": { "a": 0, "k": [472.222, 472.222, 100] }
          },
          "ao": 0,
          "shapes": [
            {
              "ty": "gr",
              "it": [
                {
                  "d": 1,
                  "ty": "el",
                  "s": { "a": 0, "k": [49.469, 49.469] },
                  "p": { "a": 0, "k": [0, 0] },
                  "nm": "Ellipse Path 1",
                  "mn": "ADBE Vector Shape - Ellipse"
                },
                {
                  "ty": "st",
                  "c": { "a": 0, "k": [0.44, 0.13, 0.47, 1] },
                  "o": { "a": 0, "k": 100 },
                  "w": { "a": 0, "k": 0 },
                  "lc": 1,
                  "lj": 1,
                  "ml": 4,
                  "nm": "Stroke 1",
                  "mn": "ADBE Vector Graphic - Stroke"
                },
                {
                  "ty": "fl",
                  "c": { "a": 0, "k": [0.53, 0.89, 0, 1] },
                  "o": { "a": 0, "k": 100 },
                  "nm": "Fill 1",
                  "mn": "ADBE Vector Graphic - Fill"
                },
                {
                  "ty": "tr",
                  "p": { "a": 0, "k": [-5.266, 38.734], "ix": 2 },
                  "a": { "a": 0, "k": [0, 0], "ix": 1 },
                  "s": { "a": 0, "k": [100, 100], "ix": 3 },
                  "r": { "a": 0, "k": 0, "ix": 6 },
                  "o": { "a": 0, "k": 100, "ix": 7 },
                  "sk": { "a": 0, "k": 0, "ix": 4 },
                  "sa": { "a": 0, "k": 0, "ix": 5 },
                  "nm": "Transform"
                }
              ],
              "nm": "Ellipse 1",
              "np": 3,
              "mn": "ADBE Vector Group"
            }
          ],
          "ip": 80,
          "op": 97,
          "st": 80,
          "bm": 0,
          "sr": 1
        },
        {
          "ddd": 0,
          "ind": 4,
          "ty": 4,
          "nm": "16",
          "parent": 1,
          "ks": {
            "o": { "a": 0, "k": 100 },
            "r": { "a": 0, "k": 0 },
            "p": { "a": 0, "k": [244.734, 38.734, 0] },
            "a": { "a": 0, "k": [-5.266, 38.734, 0] },
            "s": { "a": 0, "k": [472.222, 472.222, 100] }
          },
          "ao": 0,
          "shapes": [
            {
              "ty": "gr",
              "it": [
                {
                  "d": 1,
                  "ty": "el",
                  "s": { "a": 0, "k": [49.469, 49.469] },
                  "p": { "a": 0, "k": [0, 0] },
                  "nm": "Ellipse Path 1",
                  "mn": "ADBE Vector Shape - Ellipse"
                },
                {
                  "ty": "st",
                  "c": { "a": 0, "k": [0.44, 0.13, 0.47, 1] },
                  "o": { "a": 0, "k": 100 },
                  "w": { "a": 0, "k": 0 },
                  "lc": 1,
                  "lj": 1,
                  "ml": 4,
                  "nm": "Stroke 1",
                  "mn": "ADBE Vector Graphic - Stroke"
                },
                {
                  "ty": "fl",
                  "c": { "a": 0, "k": [0, 0.74, 1, 1] },
                  "o": { "a": 0, "k": 100 },
                  "nm": "Fill 1",
                  "mn": "ADBE Vector Graphic - Fill"
                },
                {
                  "ty": "tr",
                  "p": { "a": 0, "k": [-5.266, 38.734], "ix": 2 },
                  "a": { "a": 0, "k": [0, 0], "ix": 1 },
                  "s": { "a": 0, "k": [100, 100], "ix": 3 },
                  "r": { "a": 0, "k": 0, "ix": 6 },
                  "o": { "a": 0, "k": 100, "ix": 7 },
                  "sk": { "a": 0, "k": 0, "ix": 4 },
                  "sa": { "a": 0, "k": 0, "ix": 5 },
                  "nm": "Transform"
                }
              ],
              "nm": "Ellipse 1",
              "np": 3,
              "mn": "ADBE Vector Group"
            }
          ],
          "ip": 80,
          "op": 97,
          "st": 80,
          "bm": 0,
          "sr": 1
        },
        {
          "ddd": 0,
          "ind": 5,
          "ty": 3,
          "nm": "L G 5",
          "ks": {
            "o": { "a": 0, "k": 100 },
            "r": {
              "a": 1,
              "k": [
                {
                  "i": { "x": [0.667], "y": [1] },
                  "o": { "x": [0.333], "y": [0] },
                  "n": ["0p667_1_0p333_0"],
                  "t": 64,
                  "s": [0],
                  "e": [191]
                },
                {
                  "i": { "x": [0.667], "y": [1] },
                  "o": { "x": [0.333], "y": [0] },
                  "n": ["0p667_1_0p333_0"],
                  "t": 77,
                  "s": [191],
                  "e": [180]
                },
                { "t": 80 }
              ]
            },
            "p": { "a": 0, "k": [870, 540, 0] },
            "a": { "a": 0, "k": [-5.266, 38.734, 0] },
            "s": { "a": 0, "k": [36, 36, 100] }
          },
          "ao": 0,
          "ip": 64,
          "op": 80,
          "st": 64,
          "bm": 0,
          "sr": 1
        },
        {
          "ddd": 0,
          "ind": 7,
          "ty": 4,
          "nm": "15",
          "parent": 5,
          "ks": {
            "o": { "a": 0, "k": 100 },
            "r": { "a": 0, "k": 0 },
            "p": { "a": 0, "k": [-255.266, 38.734, 0] },
            "a": { "a": 0, "k": [-5.266, 38.734, 0] },
            "s": { "a": 0, "k": [472.222, 472.222, 100] }
          },
          "ao": 0,
          "shapes": [
            {
              "ty": "gr",
              "it": [
                {
                  "d": 1,
                  "ty": "el",
                  "s": { "a": 0, "k": [49.469, 49.469] },
                  "p": { "a": 0, "k": [0, 0] },
                  "nm": "Ellipse Path 1",
                  "mn": "ADBE Vector Shape - Ellipse"
                },
                {
                  "ty": "st",
                  "c": { "a": 0, "k": [0.44, 0.13, 0.47, 1] },
                  "o": { "a": 0, "k": 100 },
                  "w": { "a": 0, "k": 0 },
                  "lc": 1,
                  "lj": 1,
                  "ml": 4,
                  "nm": "Stroke 1",
                  "mn": "ADBE Vector Graphic - Stroke"
                },
                {
                  "ty": "fl",
                  "c": { "a": 0, "k": [0.53, 0.89, 0, 1] },
                  "o": { "a": 0, "k": 100 },
                  "nm": "Fill 1",
                  "mn": "ADBE Vector Graphic - Fill"
                },
                {
                  "ty": "tr",
                  "p": { "a": 0, "k": [-5.266, 38.734], "ix": 2 },
                  "a": { "a": 0, "k": [0, 0], "ix": 1 },
                  "s": { "a": 0, "k": [100, 100], "ix": 3 },
                  "r": { "a": 0, "k": 0, "ix": 6 },
                  "o": { "a": 0, "k": 100, "ix": 7 },
                  "sk": { "a": 0, "k": 0, "ix": 4 },
                  "sa": { "a": 0, "k": 0, "ix": 5 },
                  "nm": "Transform"
                }
              ],
              "nm": "Ellipse 1",
              "np": 3,
              "mn": "ADBE Vector Group"
            }
          ],
          "ip": 64,
          "op": 80,
          "st": 64,
          "bm": 0,
          "sr": 1
        },
        {
          "ddd": 0,
          "ind": 8,
          "ty": 4,
          "nm": "14",
          "parent": 5,
          "ks": {
            "o": { "a": 0, "k": 100 },
            "r": { "a": 0, "k": 0 },
            "p": { "a": 0, "k": [244.734, 38.734, 0] },
            "a": { "a": 0, "k": [-5.266, 38.734, 0] },
            "s": { "a": 0, "k": [472.222, 472.222, 100] }
          },
          "ao": 0,
          "shapes": [
            {
              "ty": "gr",
              "it": [
                {
                  "d": 1,
                  "ty": "el",
                  "s": { "a": 0, "k": [49.469, 49.469] },
                  "p": { "a": 0, "k": [0, 0] },
                  "nm": "Ellipse Path 1",
                  "mn": "ADBE Vector Shape - Ellipse"
                },
                {
                  "ty": "st",
                  "c": { "a": 0, "k": [0.44, 0.13, 0.47, 1] },
                  "o": { "a": 0, "k": 100 },
                  "w": { "a": 0, "k": 0 },
                  "lc": 1,
                  "lj": 1,
                  "ml": 4,
                  "nm": "Stroke 1",
                  "mn": "ADBE Vector Graphic - Stroke"
                },
                {
                  "ty": "fl",
                  "c": { "a": 0, "k": [1, 0.73, 0, 1] },
                  "o": { "a": 0, "k": 100 },
                  "nm": "Fill 1",
                  "mn": "ADBE Vector Graphic - Fill"
                },
                {
                  "ty": "tr",
                  "p": { "a": 0, "k": [-5.266, 38.734], "ix": 2 },
                  "a": { "a": 0, "k": [0, 0], "ix": 1 },
                  "s": { "a": 0, "k": [100, 100], "ix": 3 },
                  "r": { "a": 0, "k": 0, "ix": 6 },
                  "o": { "a": 0, "k": 100, "ix": 7 },
                  "sk": { "a": 0, "k": 0, "ix": 4 },
                  "sa": { "a": 0, "k": 0, "ix": 5 },
                  "nm": "Transform"
                }
              ],
              "nm": "Ellipse 1",
              "np": 3,
              "mn": "ADBE Vector Group"
            }
          ],
          "ip": 64,
          "op": 80,
          "st": 64,
          "bm": 0,
          "sr": 1
        },
        {
          "ddd": 0,
          "ind": 9,
          "ty": 4,
          "nm": "13",
          "ks": {
            "o": { "a": 0, "k": 100 },
            "r": { "a": 0, "k": 0 },
            "p": { "a": 0, "k": [1140, 540, 0] },
            "a": { "a": 0, "k": [-5.266, 38.734, 0] },
            "s": { "a": 0, "k": [170, 170, 100] }
          },
          "ao": 0,
          "shapes": [
            {
              "ty": "gr",
              "it": [
                {
                  "d": 1,
                  "ty": "el",
                  "s": { "a": 0, "k": [49.469, 49.469] },
                  "p": { "a": 0, "k": [0, 0] },
                  "nm": "Ellipse Path 1",
                  "mn": "ADBE Vector Shape - Ellipse"
                },
                {
                  "ty": "st",
                  "c": { "a": 0, "k": [0.44, 0.13, 0.47, 1] },
                  "o": { "a": 0, "k": 100 },
                  "w": { "a": 0, "k": 0 },
                  "lc": 1,
                  "lj": 1,
                  "ml": 4,
                  "nm": "Stroke 1",
                  "mn": "ADBE Vector Graphic - Stroke"
                },
                {
                  "ty": "fl",
                  "c": { "a": 0, "k": [0, 0.74, 1, 1] },
                  "o": { "a": 0, "k": 100 },
                  "nm": "Fill 1",
                  "mn": "ADBE Vector Graphic - Fill"
                },
                {
                  "ty": "tr",
                  "p": { "a": 0, "k": [-5.266, 38.734], "ix": 2 },
                  "a": { "a": 0, "k": [0, 0], "ix": 1 },
                  "s": { "a": 0, "k": [100, 100], "ix": 3 },
                  "r": { "a": 0, "k": 0, "ix": 6 },
                  "o": { "a": 0, "k": 100, "ix": 7 },
                  "sk": { "a": 0, "k": 0, "ix": 4 },
                  "sa": { "a": 0, "k": 0, "ix": 5 },
                  "nm": "Transform"
                }
              ],
              "nm": "Ellipse 1",
              "np": 3,
              "mn": "ADBE Vector Group"
            }
          ],
          "ip": 64,
          "op": 80,
          "st": 64,
          "bm": 0,
          "sr": 1
        },
        {
          "ddd": 0,
          "ind": 11,
          "ty": 3,
          "nm": "R G 4",
          "ks": {
            "o": { "a": 0, "k": 100 },
            "r": {
              "a": 1,
              "k": [
                {
                  "i": { "x": [0.667], "y": [1] },
                  "o": { "x": [0.333], "y": [0] },
                  "n": ["0p667_1_0p333_0"],
                  "t": 48,
                  "s": [0],
                  "e": [191]
                },
                {
                  "i": { "x": [0.667], "y": [1] },
                  "o": { "x": [0.333], "y": [0] },
                  "n": ["0p667_1_0p333_0"],
                  "t": 61,
                  "s": [191],
                  "e": [180]
                },
                { "t": 64 }
              ]
            },
            "p": { "a": 0, "k": [1050, 540, 0] },
            "a": { "a": 0, "k": [-5.266, 38.734, 0] },
            "s": { "a": 0, "k": [36, 36, 100] }
          },
          "ao": 0,
          "ip": 48,
          "op": 64,
          "st": 48,
          "bm": 0,
          "sr": 1
        },
        {
          "ddd": 0,
          "ind": 12,
          "ty": 4,
          "nm": "12",
          "ks": {
            "o": { "a": 0, "k": 100 },
            "r": { "a": 0, "k": 0 },
            "p": { "a": 0, "k": [780, 540, 0] },
            "a": { "a": 0, "k": [-5.266, 38.734, 0] },
            "s": { "a": 0, "k": [170, 170, 100] }
          },
          "ao": 0,
          "shapes": [
            {
              "ty": "gr",
              "it": [
                {
                  "d": 1,
                  "ty": "el",
                  "s": { "a": 0, "k": [49.469, 49.469] },
                  "p": { "a": 0, "k": [0, 0] },
                  "nm": "Ellipse Path 1",
                  "mn": "ADBE Vector Shape - Ellipse"
                },
                {
                  "ty": "st",
                  "c": { "a": 0, "k": [0.44, 0.13, 0.47, 1] },
                  "o": { "a": 0, "k": 100 },
                  "w": { "a": 0, "k": 0 },
                  "lc": 1,
                  "lj": 1,
                  "ml": 4,
                  "nm": "Stroke 1",
                  "mn": "ADBE Vector Graphic - Stroke"
                },
                {
                  "ty": "fl",
                  "c": { "a": 0, "k": [0.53, 0.89, 0, 1] },
                  "o": { "a": 0, "k": 100 },
                  "nm": "Fill 1",
                  "mn": "ADBE Vector Graphic - Fill"
                },
                {
                  "ty": "tr",
                  "p": { "a": 0, "k": [-5.266, 38.734], "ix": 2 },
                  "a": { "a": 0, "k": [0, 0], "ix": 1 },
                  "s": { "a": 0, "k": [100, 100], "ix": 3 },
                  "r": { "a": 0, "k": 0, "ix": 6 },
                  "o": { "a": 0, "k": 100, "ix": 7 },
                  "sk": { "a": 0, "k": 0, "ix": 4 },
                  "sa": { "a": 0, "k": 0, "ix": 5 },
                  "nm": "Transform"
                }
              ],
              "nm": "Ellipse 1",
              "np": 3,
              "mn": "ADBE Vector Group"
            }
          ],
          "ip": 48,
          "op": 64,
          "st": 48,
          "bm": 0,
          "sr": 1
        },
        {
          "ddd": 0,
          "ind": 13,
          "ty": 4,
          "nm": "11",
          "parent": 11,
          "ks": {
            "o": { "a": 0, "k": 100 },
            "r": { "a": 0, "k": 0 },
            "p": { "a": 0, "k": [-255.266, 38.734, 0] },
            "a": { "a": 0, "k": [-5.266, 38.734, 0] },
            "s": { "a": 0, "k": [472.222, 472.222, 100] }
          },
          "ao": 0,
          "shapes": [
            {
              "ty": "gr",
              "it": [
                {
                  "d": 1,
                  "ty": "el",
                  "s": { "a": 0, "k": [49.469, 49.469] },
                  "p": { "a": 0, "k": [0, 0] },
                  "nm": "Ellipse Path 1",
                  "mn": "ADBE Vector Shape - Ellipse"
                },
                {
                  "ty": "st",
                  "c": { "a": 0, "k": [0.44, 0.13, 0.47, 1] },
                  "o": { "a": 0, "k": 100 },
                  "w": { "a": 0, "k": 0 },
                  "lc": 1,
                  "lj": 1,
                  "ml": 4,
                  "nm": "Stroke 1",
                  "mn": "ADBE Vector Graphic - Stroke"
                },
                {
                  "ty": "fl",
                  "c": { "a": 0, "k": [0, 0.74, 1, 1] },
                  "o": { "a": 0, "k": 100 },
                  "nm": "Fill 1",
                  "mn": "ADBE Vector Graphic - Fill"
                },
                {
                  "ty": "tr",
                  "p": { "a": 0, "k": [-5.266, 38.734], "ix": 2 },
                  "a": { "a": 0, "k": [0, 0], "ix": 1 },
                  "s": { "a": 0, "k": [100, 100], "ix": 3 },
                  "r": { "a": 0, "k": 0, "ix": 6 },
                  "o": { "a": 0, "k": 100, "ix": 7 },
                  "sk": { "a": 0, "k": 0, "ix": 4 },
                  "sa": { "a": 0, "k": 0, "ix": 5 },
                  "nm": "Transform"
                }
              ],
              "nm": "Ellipse 1",
              "np": 3,
              "mn": "ADBE Vector Group"
            }
          ],
          "ip": 48,
          "op": 64,
          "st": 48,
          "bm": 0,
          "sr": 1
        },
        {
          "ddd": 0,
          "ind": 14,
          "ty": 4,
          "nm": "10",
          "parent": 11,
          "ks": {
            "o": { "a": 0, "k": 100 },
            "r": { "a": 0, "k": 0 },
            "p": { "a": 0, "k": [244.734, 38.734, 0] },
            "a": { "a": 0, "k": [-5.266, 38.734, 0] },
            "s": { "a": 0, "k": [472.222, 472.222, 100] }
          },
          "ao": 0,
          "shapes": [
            {
              "ty": "gr",
              "it": [
                {
                  "d": 1,
                  "ty": "el",
                  "s": { "a": 0, "k": [49.469, 49.469] },
                  "p": { "a": 0, "k": [0, 0] },
                  "nm": "Ellipse Path 1",
                  "mn": "ADBE Vector Shape - Ellipse"
                },
                {
                  "ty": "st",
                  "c": { "a": 0, "k": [0.44, 0.13, 0.47, 1] },
                  "o": { "a": 0, "k": 100 },
                  "w": { "a": 0, "k": 0 },
                  "lc": 1,
                  "lj": 1,
                  "ml": 4,
                  "nm": "Stroke 1",
                  "mn": "ADBE Vector Graphic - Stroke"
                },
                {
                  "ty": "fl",
                  "c": { "a": 0, "k": [1, 0.73, 0, 1] },
                  "o": { "a": 0, "k": 100 },
                  "nm": "Fill 1",
                  "mn": "ADBE Vector Graphic - Fill"
                },
                {
                  "ty": "tr",
                  "p": { "a": 0, "k": [-5.266, 38.734], "ix": 2 },
                  "a": { "a": 0, "k": [0, 0], "ix": 1 },
                  "s": { "a": 0, "k": [100, 100], "ix": 3 },
                  "r": { "a": 0, "k": 0, "ix": 6 },
                  "o": { "a": 0, "k": 100, "ix": 7 },
                  "sk": { "a": 0, "k": 0, "ix": 4 },
                  "sa": { "a": 0, "k": 0, "ix": 5 },
                  "nm": "Transform"
                }
              ],
              "nm": "Ellipse 1",
              "np": 3,
              "mn": "ADBE Vector Group"
            }
          ],
          "ip": 48,
          "op": 64,
          "st": 48,
          "bm": 0,
          "sr": 1
        },
        {
          "ddd": 0,
          "ind": 15,
          "ty": 3,
          "nm": "L G 3",
          "ks": {
            "o": { "a": 0, "k": 100 },
            "r": {
              "a": 1,
              "k": [
                {
                  "i": { "x": [0.667], "y": [1] },
                  "o": { "x": [0.333], "y": [0] },
                  "n": ["0p667_1_0p333_0"],
                  "t": 32,
                  "s": [0],
                  "e": [191]
                },
                {
                  "i": { "x": [0.667], "y": [1] },
                  "o": { "x": [0.333], "y": [0] },
                  "n": ["0p667_1_0p333_0"],
                  "t": 45,
                  "s": [191],
                  "e": [180]
                },
                { "t": 48 }
              ]
            },
            "p": { "a": 0, "k": [870, 540, 0] },
            "a": { "a": 0, "k": [-5.266, 38.734, 0] },
            "s": { "a": 0, "k": [36, 36, 100] }
          },
          "ao": 0,
          "ip": 32,
          "op": 48,
          "st": 32,
          "bm": 0,
          "sr": 1
        },
        {
          "ddd": 0,
          "ind": 17,
          "ty": 4,
          "nm": "9",
          "parent": 15,
          "ks": {
            "o": { "a": 0, "k": 100 },
            "r": { "a": 0, "k": 0 },
            "p": { "a": 0, "k": [-255.266, 38.734, 0] },
            "a": { "a": 0, "k": [-5.266, 38.734, 0] },
            "s": { "a": 0, "k": [472.222, 472.222, 100] }
          },
          "ao": 0,
          "shapes": [
            {
              "ty": "gr",
              "it": [
                {
                  "d": 1,
                  "ty": "el",
                  "s": { "a": 0, "k": [49.469, 49.469] },
                  "p": { "a": 0, "k": [0, 0] },
                  "nm": "Ellipse Path 1",
                  "mn": "ADBE Vector Shape - Ellipse"
                },
                {
                  "ty": "st",
                  "c": { "a": 0, "k": [0.44, 0.13, 0.47, 1] },
                  "o": { "a": 0, "k": 100 },
                  "w": { "a": 0, "k": 0 },
                  "lc": 1,
                  "lj": 1,
                  "ml": 4,
                  "nm": "Stroke 1",
                  "mn": "ADBE Vector Graphic - Stroke"
                },
                {
                  "ty": "fl",
                  "c": { "a": 0, "k": [0, 0.74, 1, 1] },
                  "o": { "a": 0, "k": 100 },
                  "nm": "Fill 1",
                  "mn": "ADBE Vector Graphic - Fill"
                },
                {
                  "ty": "tr",
                  "p": { "a": 0, "k": [-5.266, 38.734], "ix": 2 },
                  "a": { "a": 0, "k": [0, 0], "ix": 1 },
                  "s": { "a": 0, "k": [100, 100], "ix": 3 },
                  "r": { "a": 0, "k": 0, "ix": 6 },
                  "o": { "a": 0, "k": 100, "ix": 7 },
                  "sk": { "a": 0, "k": 0, "ix": 4 },
                  "sa": { "a": 0, "k": 0, "ix": 5 },
                  "nm": "Transform"
                }
              ],
              "nm": "Ellipse 1",
              "np": 3,
              "mn": "ADBE Vector Group"
            }
          ],
          "ip": 32,
          "op": 48,
          "st": 32,
          "bm": 0,
          "sr": 1
        },
        {
          "ddd": 0,
          "ind": 18,
          "ty": 4,
          "nm": "8",
          "parent": 15,
          "ks": {
            "o": { "a": 0, "k": 100 },
            "r": { "a": 0, "k": 0 },
            "p": { "a": 0, "k": [244.734, 38.734, 0] },
            "a": { "a": 0, "k": [-5.266, 38.734, 0] },
            "s": { "a": 0, "k": [472.222, 472.222, 100] }
          },
          "ao": 0,
          "shapes": [
            {
              "ty": "gr",
              "it": [
                {
                  "d": 1,
                  "ty": "el",
                  "s": { "a": 0, "k": [49.469, 49.469] },
                  "p": { "a": 0, "k": [0, 0] },
                  "nm": "Ellipse Path 1",
                  "mn": "ADBE Vector Shape - Ellipse"
                },
                {
                  "ty": "st",
                  "c": { "a": 0, "k": [0.44, 0.13, 0.47, 1] },
                  "o": { "a": 0, "k": 100 },
                  "w": { "a": 0, "k": 0 },
                  "lc": 1,
                  "lj": 1,
                  "ml": 4,
                  "nm": "Stroke 1",
                  "mn": "ADBE Vector Graphic - Stroke"
                },
                {
                  "ty": "fl",
                  "c": { "a": 0, "k": [0.53, 0.89, 0, 1] },
                  "o": { "a": 0, "k": 100 },
                  "nm": "Fill 1",
                  "mn": "ADBE Vector Graphic - Fill"
                },
                {
                  "ty": "tr",
                  "p": { "a": 0, "k": [-5.266, 38.734], "ix": 2 },
                  "a": { "a": 0, "k": [0, 0], "ix": 1 },
                  "s": { "a": 0, "k": [100, 100], "ix": 3 },
                  "r": { "a": 0, "k": 0, "ix": 6 },
                  "o": { "a": 0, "k": 100, "ix": 7 },
                  "sk": { "a": 0, "k": 0, "ix": 4 },
                  "sa": { "a": 0, "k": 0, "ix": 5 },
                  "nm": "Transform"
                }
              ],
              "nm": "Ellipse 1",
              "np": 3,
              "mn": "ADBE Vector Group"
            }
          ],
          "ip": 32,
          "op": 48,
          "st": 32,
          "bm": 0,
          "sr": 1
        },
        {
          "ddd": 0,
          "ind": 19,
          "ty": 4,
          "nm": "7",
          "ks": {
            "o": { "a": 0, "k": 100 },
            "r": { "a": 0, "k": 0 },
            "p": { "a": 0, "k": [1140, 540, 0] },
            "a": { "a": 0, "k": [-5.266, 38.734, 0] },
            "s": { "a": 0, "k": [170, 170, 100] }
          },
          "ao": 0,
          "shapes": [
            {
              "ty": "gr",
              "it": [
                {
                  "d": 1,
                  "ty": "el",
                  "s": { "a": 0, "k": [49.469, 49.469] },
                  "p": { "a": 0, "k": [0, 0] },
                  "nm": "Ellipse Path 1",
                  "mn": "ADBE Vector Shape - Ellipse"
                },
                {
                  "ty": "st",
                  "c": { "a": 0, "k": [0.44, 0.13, 0.47, 1] },
                  "o": { "a": 0, "k": 100 },
                  "w": { "a": 0, "k": 0 },
                  "lc": 1,
                  "lj": 1,
                  "ml": 4,
                  "nm": "Stroke 1",
                  "mn": "ADBE Vector Graphic - Stroke"
                },
                {
                  "ty": "fl",
                  "c": { "a": 0, "k": [1, 0.73, 0, 1] },
                  "o": { "a": 0, "k": 100 },
                  "nm": "Fill 1",
                  "mn": "ADBE Vector Graphic - Fill"
                },
                {
                  "ty": "tr",
                  "p": { "a": 0, "k": [-5.266, 38.734], "ix": 2 },
                  "a": { "a": 0, "k": [0, 0], "ix": 1 },
                  "s": { "a": 0, "k": [100, 100], "ix": 3 },
                  "r": { "a": 0, "k": 0, "ix": 6 },
                  "o": { "a": 0, "k": 100, "ix": 7 },
                  "sk": { "a": 0, "k": 0, "ix": 4 },
                  "sa": { "a": 0, "k": 0, "ix": 5 },
                  "nm": "Transform"
                }
              ],
              "nm": "Ellipse 1",
              "np": 3,
              "mn": "ADBE Vector Group"
            }
          ],
          "ip": 32,
          "op": 48,
          "st": 32,
          "bm": 0,
          "sr": 1
        },
        {
          "ddd": 0,
          "ind": 21,
          "ty": 3,
          "nm": "R G 2",
          "ks": {
            "o": { "a": 0, "k": 100 },
            "r": {
              "a": 1,
              "k": [
                {
                  "i": { "x": [0.667], "y": [1] },
                  "o": { "x": [0.333], "y": [0] },
                  "n": ["0p667_1_0p333_0"],
                  "t": 16,
                  "s": [0],
                  "e": [191]
                },
                {
                  "i": { "x": [0.667], "y": [1] },
                  "o": { "x": [0.333], "y": [0] },
                  "n": ["0p667_1_0p333_0"],
                  "t": 29,
                  "s": [191],
                  "e": [180]
                },
                { "t": 32 }
              ]
            },
            "p": { "a": 0, "k": [1050, 540, 0] },
            "a": { "a": 0, "k": [-5.266, 38.734, 0] },
            "s": { "a": 0, "k": [36, 36, 100] }
          },
          "ao": 0,
          "ip": 16,
          "op": 32,
          "st": 16,
          "bm": 0,
          "sr": 1
        },
        {
          "ddd": 0,
          "ind": 22,
          "ty": 4,
          "nm": "6",
          "ks": {
            "o": { "a": 0, "k": 100 },
            "r": { "a": 0, "k": 0 },
            "p": { "a": 0, "k": [780, 540, 0] },
            "a": { "a": 0, "k": [-5.266, 38.734, 0] },
            "s": { "a": 0, "k": [170, 170, 100] }
          },
          "ao": 0,
          "shapes": [
            {
              "ty": "gr",
              "it": [
                {
                  "d": 1,
                  "ty": "el",
                  "s": { "a": 0, "k": [49.469, 49.469] },
                  "p": { "a": 0, "k": [0, 0] },
                  "nm": "Ellipse Path 1",
                  "mn": "ADBE Vector Shape - Ellipse"
                },
                {
                  "ty": "st",
                  "c": { "a": 0, "k": [0.44, 0.13, 0.47, 1] },
                  "o": { "a": 0, "k": 100 },
                  "w": { "a": 0, "k": 0 },
                  "lc": 1,
                  "lj": 1,
                  "ml": 4,
                  "nm": "Stroke 1",
                  "mn": "ADBE Vector Graphic - Stroke"
                },
                {
                  "ty": "fl",
                  "c": { "a": 0, "k": [0, 0.74, 1, 1] },
                  "o": { "a": 0, "k": 100 },
                  "nm": "Fill 1",
                  "mn": "ADBE Vector Graphic - Fill"
                },
                {
                  "ty": "tr",
                  "p": { "a": 0, "k": [-5.266, 38.734], "ix": 2 },
                  "a": { "a": 0, "k": [0, 0], "ix": 1 },
                  "s": { "a": 0, "k": [100, 100], "ix": 3 },
                  "r": { "a": 0, "k": 0, "ix": 6 },
                  "o": { "a": 0, "k": 100, "ix": 7 },
                  "sk": { "a": 0, "k": 0, "ix": 4 },
                  "sa": { "a": 0, "k": 0, "ix": 5 },
                  "nm": "Transform"
                }
              ],
              "nm": "Ellipse 1",
              "np": 3,
              "mn": "ADBE Vector Group"
            }
          ],
          "ip": 16,
          "op": 32,
          "st": 16,
          "bm": 0,
          "sr": 1
        },
        {
          "ddd": 0,
          "ind": 23,
          "ty": 4,
          "nm": "5",
          "parent": 21,
          "ks": {
            "o": { "a": 0, "k": 100 },
            "r": { "a": 0, "k": 0 },
            "p": { "a": 0, "k": [-255.266, 38.734, 0] },
            "a": { "a": 0, "k": [-5.266, 38.734, 0] },
            "s": { "a": 0, "k": [472.222, 472.222, 100] }
          },
          "ao": 0,
          "shapes": [
            {
              "ty": "gr",
              "it": [
                {
                  "d": 1,
                  "ty": "el",
                  "s": { "a": 0, "k": [49.469, 49.469] },
                  "p": { "a": 0, "k": [0, 0] },
                  "nm": "Ellipse Path 1",
                  "mn": "ADBE Vector Shape - Ellipse"
                },
                {
                  "ty": "st",
                  "c": { "a": 0, "k": [0.44, 0.13, 0.47, 1] },
                  "o": { "a": 0, "k": 100 },
                  "w": { "a": 0, "k": 0 },
                  "lc": 1,
                  "lj": 1,
                  "ml": 4,
                  "nm": "Stroke 1",
                  "mn": "ADBE Vector Graphic - Stroke"
                },
                {
                  "ty": "fl",
                  "c": { "a": 0, "k": [1, 0.73, 0, 1] },
                  "o": { "a": 0, "k": 100 },
                  "nm": "Fill 1",
                  "mn": "ADBE Vector Graphic - Fill"
                },
                {
                  "ty": "tr",
                  "p": { "a": 0, "k": [-5.266, 38.734], "ix": 2 },
                  "a": { "a": 0, "k": [0, 0], "ix": 1 },
                  "s": { "a": 0, "k": [100, 100], "ix": 3 },
                  "r": { "a": 0, "k": 0, "ix": 6 },
                  "o": { "a": 0, "k": 100, "ix": 7 },
                  "sk": { "a": 0, "k": 0, "ix": 4 },
                  "sa": { "a": 0, "k": 0, "ix": 5 },
                  "nm": "Transform"
                }
              ],
              "nm": "Ellipse 1",
              "np": 3,
              "mn": "ADBE Vector Group"
            }
          ],
          "ip": 16,
          "op": 32,
          "st": 16,
          "bm": 0,
          "sr": 1
        },
        {
          "ddd": 0,
          "ind": 24,
          "ty": 4,
          "nm": "4",
          "parent": 21,
          "ks": {
            "o": { "a": 0, "k": 100 },
            "r": { "a": 0, "k": 0 },
            "p": { "a": 0, "k": [244.734, 38.734, 0] },
            "a": { "a": 0, "k": [-5.266, 38.734, 0] },
            "s": { "a": 0, "k": [472.222, 472.222, 100] }
          },
          "ao": 0,
          "shapes": [
            {
              "ty": "gr",
              "it": [
                {
                  "d": 1,
                  "ty": "el",
                  "s": { "a": 0, "k": [49.469, 49.469] },
                  "p": { "a": 0, "k": [0, 0] },
                  "nm": "Ellipse Path 1",
                  "mn": "ADBE Vector Shape - Ellipse"
                },
                {
                  "ty": "st",
                  "c": { "a": 0, "k": [0.44, 0.13, 0.47, 1] },
                  "o": { "a": 0, "k": 100 },
                  "w": { "a": 0, "k": 0 },
                  "lc": 1,
                  "lj": 1,
                  "ml": 4,
                  "nm": "Stroke 1",
                  "mn": "ADBE Vector Graphic - Stroke"
                },
                {
                  "ty": "fl",
                  "c": { "a": 0, "k": [0.53, 0.89, 0.01, 1] },
                  "o": { "a": 0, "k": 100 },
                  "nm": "Fill 1",
                  "mn": "ADBE Vector Graphic - Fill"
                },
                {
                  "ty": "tr",
                  "p": { "a": 0, "k": [-5.266, 38.734], "ix": 2 },
                  "a": { "a": 0, "k": [0, 0], "ix": 1 },
                  "s": { "a": 0, "k": [100, 100], "ix": 3 },
                  "r": { "a": 0, "k": 0, "ix": 6 },
                  "o": { "a": 0, "k": 100, "ix": 7 },
                  "sk": { "a": 0, "k": 0, "ix": 4 },
                  "sa": { "a": 0, "k": 0, "ix": 5 },
                  "nm": "Transform"
                }
              ],
              "nm": "Ellipse 1",
              "np": 3,
              "mn": "ADBE Vector Group"
            }
          ],
          "ip": 16,
          "op": 32,
          "st": 16,
          "bm": 0,
          "sr": 1
        },
        {
          "ddd": 0,
          "ind": 25,
          "ty": 3,
          "nm": "L G",
          "ks": {
            "o": { "a": 0, "k": 100 },
            "r": {
              "a": 1,
              "k": [
                {
                  "i": { "x": [0.667], "y": [1] },
                  "o": { "x": [0.333], "y": [0] },
                  "n": ["0p667_1_0p333_0"],
                  "t": 0,
                  "s": [0],
                  "e": [191]
                },
                {
                  "i": { "x": [0.667], "y": [1] },
                  "o": { "x": [0.333], "y": [0] },
                  "n": ["0p667_1_0p333_0"],
                  "t": 13,
                  "s": [191],
                  "e": [180]
                },
                { "t": 16 }
              ]
            },
            "p": { "a": 0, "k": [870, 540, 0] },
            "a": { "a": 0, "k": [-5.266, 38.734, 0] },
            "s": { "a": 0, "k": [36, 36, 100] }
          },
          "ao": 0,
          "ip": 0,
          "op": 16,
          "st": 0,
          "bm": 0,
          "sr": 1
        },
        {
          "ddd": 0,
          "ind": 27,
          "ty": 4,
          "nm": "1",
          "parent": 25,
          "ks": {
            "o": { "a": 0, "k": 100 },
            "r": { "a": 0, "k": 0 },
            "p": { "a": 0, "k": [-255.266, 38.734, 0] },
            "a": { "a": 0, "k": [-5.266, 38.734, 0] },
            "s": { "a": 0, "k": [472.222, 472.222, 100] }
          },
          "ao": 0,
          "shapes": [
            {
              "ty": "gr",
              "it": [
                {
                  "d": 1,
                  "ty": "el",
                  "s": { "a": 0, "k": [49.469, 49.469] },
                  "p": { "a": 0, "k": [0, 0] },
                  "nm": "Ellipse Path 1",
                  "mn": "ADBE Vector Shape - Ellipse"
                },
                {
                  "ty": "st",
                  "c": { "a": 0, "k": [0.44, 0.13, 0.47, 1] },
                  "o": { "a": 0, "k": 100 },
                  "w": { "a": 0, "k": 0 },
                  "lc": 1,
                  "lj": 1,
                  "ml": 4,
                  "nm": "Stroke 1",
                  "mn": "ADBE Vector Graphic - Stroke"
                },
                {
                  "ty": "fl",
                  "c": { "a": 0, "k": [1, 0.73, 0, 1] },
                  "o": { "a": 0, "k": 100 },
                  "nm": "Fill 1",
                  "mn": "ADBE Vector Graphic - Fill"
                },
                {
                  "ty": "tr",
                  "p": { "a": 0, "k": [-5.266, 38.734], "ix": 2 },
                  "a": { "a": 0, "k": [0, 0], "ix": 1 },
                  "s": { "a": 0, "k": [100, 100], "ix": 3 },
                  "r": { "a": 0, "k": 0, "ix": 6 },
                  "o": { "a": 0, "k": 100, "ix": 7 },
                  "sk": { "a": 0, "k": 0, "ix": 4 },
                  "sa": { "a": 0, "k": 0, "ix": 5 },
                  "nm": "Transform"
                }
              ],
              "nm": "Ellipse 1",
              "np": 3,
              "mn": "ADBE Vector Group"
            }
          ],
          "ip": 0,
          "op": 16,
          "st": 0,
          "bm": 0,
          "sr": 1
        },
        {
          "ddd": 0,
          "ind": 28,
          "ty": 4,
          "nm": "2",
          "parent": 25,
          "ks": {
            "o": { "a": 0, "k": 100 },
            "r": { "a": 0, "k": 0 },
            "p": { "a": 0, "k": [244.734, 38.734, 0] },
            "a": { "a": 0, "k": [-5.266, 38.734, 0] },
            "s": { "a": 0, "k": [472.222, 472.222, 100] }
          },
          "ao": 0,
          "shapes": [
            {
              "ty": "gr",
              "it": [
                {
                  "d": 1,
                  "ty": "el",
                  "s": { "a": 0, "k": [49.469, 49.469] },
                  "p": { "a": 0, "k": [0, 0] },
                  "nm": "Ellipse Path 1",
                  "mn": "ADBE Vector Shape - Ellipse"
                },
                {
                  "ty": "st",
                  "c": { "a": 0, "k": [0.44, 0.13, 0.47, 1] },
                  "o": { "a": 0, "k": 100 },
                  "w": { "a": 0, "k": 0 },
                  "lc": 1,
                  "lj": 1,
                  "ml": 4,
                  "nm": "Stroke 1",
                  "mn": "ADBE Vector Graphic - Stroke"
                },
                {
                  "ty": "fl",
                  "c": { "a": 0, "k": [0, 0.74, 1, 1] },
                  "o": { "a": 0, "k": 100 },
                  "nm": "Fill 1",
                  "mn": "ADBE Vector Graphic - Fill"
                },
                {
                  "ty": "tr",
                  "p": { "a": 0, "k": [-5.266, 38.734], "ix": 2 },
                  "a": { "a": 0, "k": [0, 0], "ix": 1 },
                  "s": { "a": 0, "k": [100, 100], "ix": 3 },
                  "r": { "a": 0, "k": 0, "ix": 6 },
                  "o": { "a": 0, "k": 100, "ix": 7 },
                  "sk": { "a": 0, "k": 0, "ix": 4 },
                  "sa": { "a": 0, "k": 0, "ix": 5 },
                  "nm": "Transform"
                }
              ],
              "nm": "Ellipse 1",
              "np": 3,
              "mn": "ADBE Vector Group"
            }
          ],
          "ip": 0,
          "op": 16,
          "st": 0,
          "bm": 0,
          "sr": 1
        },
        {
          "ddd": 0,
          "ind": 29,
          "ty": 4,
          "nm": "3",
          "ks": {
            "o": { "a": 0, "k": 100 },
            "r": { "a": 0, "k": 0 },
            "p": { "a": 0, "k": [1140, 540, 0] },
            "a": { "a": 0, "k": [-5.266, 38.734, 0] },
            "s": { "a": 0, "k": [170, 170, 100] }
          },
          "ao": 0,
          "shapes": [
            {
              "ty": "gr",
              "it": [
                {
                  "d": 1,
                  "ty": "el",
                  "s": { "a": 0, "k": [49.469, 49.469] },
                  "p": { "a": 0, "k": [0, 0] },
                  "nm": "Ellipse Path 1",
                  "mn": "ADBE Vector Shape - Ellipse"
                },
                {
                  "ty": "st",
                  "c": { "a": 0, "k": [0.44, 0.13, 0.47, 1] },
                  "o": { "a": 0, "k": 100 },
                  "w": { "a": 0, "k": 0 },
                  "lc": 1,
                  "lj": 1,
                  "ml": 4,
                  "nm": "Stroke 1",
                  "mn": "ADBE Vector Graphic - Stroke"
                },
                {
                  "ty": "fl",
                  "c": { "a": 0, "k": [0.53, 0.89, 0.01, 1] },
                  "o": { "a": 0, "k": 100 },
                  "nm": "Fill 1",
                  "mn": "ADBE Vector Graphic - Fill"
                },
                {
                  "ty": "tr",
                  "p": { "a": 0, "k": [-5.266, 38.734], "ix": 2 },
                  "a": { "a": 0, "k": [0, 0], "ix": 1 },
                  "s": { "a": 0, "k": [100, 100], "ix": 3 },
                  "r": { "a": 0, "k": 0, "ix": 6 },
                  "o": { "a": 0, "k": 100, "ix": 7 },
                  "sk": { "a": 0, "k": 0, "ix": 4 },
                  "sa": { "a": 0, "k": 0, "ix": 5 },
                  "nm": "Transform"
                }
              ],
              "nm": "Ellipse 1",
              "np": 3,
              "mn": "ADBE Vector Group"
            }
          ],
          "ip": 0,
          "op": 16,
          "st": 0,
          "bm": 0,
          "sr": 1
        }
      ]
    }
  ],
  "layers": [
    {
      "ddd": 0,
      "ind": 1,
      "ty": 0,
      "nm": "L 2",
      "refId": "comp_29",
      "ks": {
        "o": { "a": 0, "k": 100 },
        "r": { "a": 0, "k": 0 },
        "p": { "a": 0, "k": [256, 256, 0] },
        "a": { "a": 0, "k": [960, 540, 0] },
        "s": { "a": 0, "k": [107.593, 107.593, 100] }
      },
      "ao": 0,
      "w": 1920,
      "h": 1080,
      "ip": 0,
      "op": 450,
      "st": 0,
      "bm": 0,
      "sr": 1
    }
  ]
}
